/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as r } from "../chunks/tslib.es6.js";
import { JSONMap as e } from "../core/jsonMap.js";
import { JSONSupport as t } from "../core/JSONSupport.js";
import { property as s } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import { subclass as o } from "../core/accessorSupport/decorators/subclass.js";
import i from "./support/AuthoringInfo.js";
const n = new e({
  simple: "simple",
  uniqueValue: "unique-value",
  classBreaks: "class-breaks",
  heatmap: "heatmap",
  dotDensity: "dot-density",
  dictionary: "dictionary",
  pieChart: "pie-chart"
}, {
  ignoreUnknown: !0
});
let a = class extends t {
  constructor(r) {
    super(r), this.authoringInfo = null, this.type = null;
  }
  async getRequiredFields(r) {
    if (!this.collectRequiredFields) return [];
    const e = new Set();
    return await this.collectRequiredFields(e, r), Array.from(e).sort();
  }
  getSymbol(r, e) {}
  async getSymbolAsync(r, e) {}
  getSymbols() {
    return [];
  }
  getAttributeHash() {
    return JSON.stringify(this);
  }
  getMeshHash() {
    return JSON.stringify(this);
  }
};
r([s({
  type: i,
  json: {
    write: !0
  }
})], a.prototype, "authoringInfo", void 0), r([s({
  type: n.apiValues,
  readOnly: !0,
  json: {
    type: n.jsonValues,
    read: !1,
    write: {
      writer: n.write,
      ignoreOrigin: !0
    }
  }
})], a.prototype, "type", void 0), a = r([o("esri.renderers.Renderer")], a);
const p = a;
export { p as default };